<template>
    <nav class="navigation-footer">
        <ul class="list list-inline">
            <li
                v-for="item in items"
                :key="item.title"
            >
                <a 
                    :href="item.url" 
                    :target="item.target || '_blank'" 
                    :title="item.title" 
                    class="link-underline-in"
                    rel="noreferrer"
                >
                    {{ item.title | bastards }}
                </a>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            required: true
        }
    }
}
</script>

<style lang="scss">
.navigation-footer {
    > ul {
        > li {
            &:not(:first-child) {
                position: relative;
                padding-left: 20px;

                &:before {
                    content: '';
                    background-color: $color-default-light;
                    position: absolute;
                    left: 9px;
                    top: 3px;
                    bottom: 3px;
                    width: 1px;
                }
            }
        }
    }
}
</style>
